import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {DbService} from './db-service/db.service';
import {
  BusinessServiceService
} from '../master-config-components/micro-apps/business/services/business-service.service';
import {SubscriptionService} from './subscription.service';
import {StorageKeys} from '../shared-module-files/simpo.constant';
import {tap} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _dbService: DbService,
    private router: ActivatedRoute,
    private businessService: BusinessServiceService,
    private subscriptionService: SubscriptionService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const businessId = route.queryParams['businessId'];
    const staffId = route.queryParams['staffId'];

    if (businessId && staffId) {
      localStorage.setItem("businessId", businessId)
      localStorage.setItem("staffId", staffId)
      return this.businessService.getDetailsByBusinessId(businessId, staffId).pipe(
        tap((res: any) => {
          window.localStorage.setItem('bDetails', JSON.stringify(res.data.business));
          localStorage.setItem(StorageKeys.BUSINESS_NAME, res.data.business.name);
          localStorage.setItem('subIndustryName', res.data.business.subIndustryName);
          localStorage.setItem(StorageKeys.PERMISSIONS, JSON.stringify(res.data.staffPermissions))
          localStorage.setItem(StorageKeys.SUBINDUSTRYID, res.data?.business?.subIndustryId);
          localStorage.setItem('mobileLogin', 'true');
          this._dbService.setBusinessId(res.data.business.id);
          window.localStorage.setItem('type', 'admin');
          this.subscriptionService.changeCurrentPlanDetails();
          this._router.navigateByUrl(state.url.split('?')[0])
        })
      );

    } else {
      if (this._dbService.getBusinessId()) {
        return true;
      }
      this._router.navigate(['']);
      return false;
    }
  }

}
